import { render, staticRenderFns } from "./MapVIDA.component.vue?vue&type=template&id=12656f3e&scoped=true"
import script from "./MapVIDA.component.vue?vue&type=script&lang=ts"
export * from "./MapVIDA.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12656f3e",
  null
  
)

export default component.exports